import { Observable } from '../observable.js';
import { ActionNode } from './action-node.js';
export class TraySpawnChoiceNode extends ActionNode {
    constructor(id, data, type, implementationFunction = null) {
        super(id, data, type, implementationFunction);
        const choiceRef = new Observable();
        this.data.choiceRef = choiceRef;
    }
}
